import { z } from "zod";

export const homeRouteSearchSchema = z.object({
  firstRun: z.coerce.number().int().optional(),
});

export type HomeRouteSearch = z.infer<typeof homeRouteSearchSchema>;
